import {z} from 'zod';
import {zDateTime, zWbBoolean} from '@brunata-angular/util';
import {DateTime} from 'luxon';

const webArchiveDocumentSchema = z
    .object({
        secondsectorno: z.string().nullable(),
        firstsectorno: z.string().nullable(),
        locationno: z.string().nullable(),
        consumername: z.string().nullable(),
        consumerno: z.string().nullable(),
        street: z.string().nullable(),
        stairway: z.string().nullable(),
        floor: z.string().nullable(),
        accounttype: z.string(),
        accountno: z.string(),
        periodenddate: zDateTime,
        cutoffdate: zDateTime,
        version: z
            .string()
            .transform(version => DateTime.fromFormat(version.substring(0, 12), 'yyyyMMddhhmm')),
        correctedbillmarking: zWbBoolean,
        visibletoresident: zWbBoolean,
        docid: z.string(),
        docurl: z.string(),
    })
    .transform(it => ({
        propertyNo: it.secondsectorno,
        branchNo: it.firstsectorno,
        locationNo: it.locationno,
        residentNo: it.consumerno,
        residentName: it.consumername,
        street: it.street,
        stairway: it.stairway,
        floor: it.floor,
        accountType: it.accounttype,
        accountNo: it.accountno,
        periodEndDate: it.periodenddate,
        cutOffDate: it.cutoffdate,
        version: it.version,
        correctedBill: it.correctedbillmarking,
        visibleToResident: it.visibletoresident,
        docId: it.docid,
        docUrl: it.docurl,
    }));

export const webArchiveResultSchema = z.object({
    documents: z.array(webArchiveDocumentSchema),
    limited: z.boolean(),
});

export type WebArchiveResult = z.output<typeof webArchiveResultSchema>;
export type WebArchiveDocument = z.output<typeof webArchiveDocumentSchema>;
